var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"newsTop"}},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":_vm.newsBg}})]),_c('div',{staticClass:"contents"},[_c('Pickup'),_c('NewsList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }